import { oz } from '@weft/utils';

export const EVENT_METERING_STATUSES = {
  Ingested: 'Ingested',
  Matched: 'Matched',
  Measured: 'Measured',
} as const;

export const EventMeteringStatusSchema = oz.nativeEnum(EVENT_METERING_STATUSES);

export type EventMeteringStatus = oz.infer<typeof EventMeteringStatusSchema>;